module.exports = __webpack_public_path__ + "static/media/img_login.b346a808.png";